import { EditorIFrame } from './EditorIFrame';
import { EditorText } from './EditorText';
import { EditorHtml } from './EditorHtml';
import { EditorTable } from './EditorTable';
import { EditorExpressionField } from './EditorExpressionField';
import { EditorDocumentPreview } from './EditorDocumentPreview';

export const editorFormFields = [
  EditorIFrame,
  EditorText,
  EditorHtml,
  EditorTable,
  EditorExpressionField,
  EditorDocumentPreview,
];
